//   \u0645\u0632\u0645\u0644\u06D5\u0634
export default{
    main:{
        message:"message",
        display:'show',
    }

}